<script>
import { mapGetters } from "vuex";

import axios from "axios";

export default {
  props: {
    label_filtro: String,
    tipoFiltro: {
      type: String,
      default: "cliente_id",
    },
  },
  emits: ["limpiar", "submit"],
  data() {
    return {
      formFiltro: [],
      items: [],
    };
  },
  computed: {
    ...mapGetters({
      filtro: "filtros/filtro",
    }),
  },
  methods: {
    borrarFiltro() {
      this.formFiltro = [];
      this.$emit("limpiar");
    },
    changeValue(id, campo) {
      this.formFiltro = [{ id: id, type: this.tipoFiltro, value: campo }];
    },  
    async fetchClientsListable() {
      let query = {
        params: {
          get: `["clientes"]`,
        },
      };

      const { data } = await axios.get(`/api/list`, query);

      if (data?.data?.clientes) {
        this.items = data?.data?.clientes?.map((client) => ({
          id: client.key,
          text: client.value,
        }));
      } else {
        return [];
      }
    },
  },
  mounted() {
    this.fetchClientsListable();
  },
};
</script>

<template>
  <form
    class="flex flex-col gap-4"
    @submit.prevent="$emit('submit', formFiltro)"
  >
    <div class="flex flex-col text-left">
      <label>{{ label_filtro ?? "" }}</label>
      <Select2
        @change="(value) => changeValue(filtro.id, value)"
        :options="items"
        :settings="{
          noResults: 'es',
          placeholder: 'Seleccione un Cliente',
          width: '100%',
          multiple: false,
        }"
      />
    </div>

    <div class="flex flex-row justify-end items-center gap-2">
      <button type="submit" class="btn-principal">Filtrar</button>

      <button
        type="button"
        @click="borrarFiltro"
        class="btn-secundario btn-small"
      >
        Limpiar
      </button>
    </div>
  </form>
</template>
